"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _SocialMedia = _interopRequireDefault(require("../../../../molecules/SocialMedia"));
var _InternalLink = _interopRequireDefault(require("../../../../atoms/InternalLink"));
var _OutboundLink = _interopRequireDefault(require("../../../../atoms/OutboundLink"));
var CenterStackedBody = function CenterStackedBody(props) {
  var pages = props.pages,
    logo = props.logo,
    bodyColor = props.bodyColor,
    socialMedia = props.socialMedia,
    pagesClassName = props.pagesClassName;
  var PagesSection = function PagesSection() {
    return pages.map(function (page) {
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
        key: "footer-center-".concat(page.title),
        style: {
          paddingBottom: '5px',
          paddingTop: '5px'
        }
      }, page.pages.map(function (pagesItem) {
        var columns = Math.floor(16 / page.pages.length);
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
          width: columns,
          centered: true,
          textAlign: "center",
          className: pagesClassName,
          floated: "right",
          key: "footer-center-".concat(pagesItem.slug)
        }, pagesItem.internal ? /*#__PURE__*/_react["default"].createElement(_InternalLink["default"], {
          to: pagesItem.slug,
          label: pagesItem.pageTitle
        }) : /*#__PURE__*/_react["default"].createElement(_OutboundLink["default"], {
          to: pagesItem.slug,
          label: pagesItem.pageTitle
        }));
      }));
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: bodyColor,
      paddingTop: '2.5em',
      paddingBottom: '2em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
    style: {
      paddingBottom: '2em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 6,
    tablet: 6,
    mobile: 2
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 4,
    tablet: 4,
    mobile: 12,
    verticalAlign: "middle",
    textAlign: "center"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    src: logo,
    centered: true,
    fluid: true,
    verticalAlign: "middle"
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    mobile: 2,
    only: "mobile"
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 5,
    tablet: 5,
    textAlign: "right",
    only: "tablet computer"
  }, /*#__PURE__*/_react["default"].createElement(_SocialMedia["default"], {
    socialMediaValues: socialMedia,
    buttonType: "rect"
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    mobile: 16,
    textAlign: "center",
    only: "mobile"
  }, /*#__PURE__*/_react["default"].createElement(_SocialMedia["default"], {
    socialMediaValues: socialMedia,
    buttonType: "rect"
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 1,
    tablet: 1,
    floated: "right",
    only: "tablet computer"
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
    stackable: true,
    container: true
  }, /*#__PURE__*/_react["default"].createElement(PagesSection, null)));
};
CenterStackedBody.propTypes = {
  bodyColor: _propTypes["default"].string.isRequired,
  pagesClassName: _propTypes["default"].string
};
CenterStackedBody.defaultProps = {
  pagesClassName: 'footer-pages'
};
var _default = CenterStackedBody;
exports["default"] = _default;